import { fetchMentorClassPortfolio } from "classroom/api/teacher";
import { defineStore } from "pinia";
import { selectedFiltersToQueryParams } from "shared/mappers/filter.mapper";
import type { SelectedFilters } from "shared/types";
import type {
  MyStudentsProgress,
  PortfolioStudentSortState,
} from "portfolio/types";

export const useClassroomMentorClassPortfolioStore = defineStore(
  "classroomMentorClassPortfolio",
  () => {
    const loadStudents = async (
      mentorClass: string,
      filters: SelectedFilters,
      sort: PortfolioStudentSortState,
      signal?: AbortSignal,
    ): Promise<MyStudentsProgress> => {
      const params = {
        ...selectedFiltersToQueryParams(filters),
        sort: sort.sort,
        order: sort.order,
      };

      return fetchMentorClassPortfolio(mentorClass, params, signal);
    };

    return { loadStudents };
  },
);
